import * as z from "zod/v4";

export const aeoGranularity = ["daily", "weekly"] as const;
export type AeoGranularity = (typeof aeoGranularity)[number];

const aeoDateRangeInput_ = z.object({
  startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  models: z.array(z.string()).optional(),
  granularity: z.enum(aeoGranularity).optional(),
});

export const aeoDateRangeInput: z.ZodType<AeoDateRangeInput> =
  aeoDateRangeInput_;
export interface AeoDateRangeInput extends z.infer<typeof aeoDateRangeInput_> {}

const aeoDashboardFilterInput_ = z.object({
  startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  models: z.array(z.string()).optional(),
  competitorIds: z.array(z.string()).optional(),
  topicIds: z.array(z.string()).optional(),
});

export const aeoDashboardFilterInput: z.ZodType<AeoDashboardFilterInput> =
  aeoDashboardFilterInput_;
export interface AeoDashboardFilterInput
  extends z.infer<typeof aeoDashboardFilterInput_> {}
